import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class OwnedProductsResource extends AuthenticatedResource {
  static urlRoot = '/owned_products' as const

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }

}
